<template>
  <router-view />
</template>
  <script>
  export default {
    name: 'IntegracaoModule',
  }
  </script>
